import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Biggen } from "../directives/biggen";
import { RouterLink } from '@angular/router';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-gospels',
  imports: [Biggen, RouterLink, Link],
  templateUrl: './gospels.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './gospels.scss',
})
export class Gospels {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Gospels`);
    this.dynamicTitle.description(`The gospels were written decades after Jesus supposed lifetime and contain many contradictions and inconsistencies.`);
  }
}
